import { DataContext } from 'contexts/DataContextContainer'
import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import YourBookCards from './YourBookCards'
import YourBookHero from './YourBookHero'
import { YourBookContainer } from './style'

function YourBook() {
  const { lang } = useContext(DataContext)
  const { t } = useTranslation()
  useEffect(() => {
    document.title = t('pg_title_your_book')
  }, [lang, t])

  return (
    <YourBookContainer>
      <YourBookHero />
      <YourBookCards />
    </YourBookContainer>
  )
}

export default YourBook
